import { Pipe, PipeTransform } from '@angular/core'

import { Enums } from '@cyborg-monorepo/hunter/common'

@Pipe({
  name: 'companyStatus',
  pure: true,
  standalone: false,
})
export class CompanyStatusPipe implements PipeTransform {
  transform(value: Enums.CompanyStatus | string): string {
    if (!value) return ''

    switch (value) {
      case Enums.CompanyStatus.TRIAL:
        return 'Community'
      case Enums.CompanyStatus.ACTIVE:
        return 'Premium'
      case Enums.CompanyStatus.POC:
        return 'Prospect'
      case Enums.CompanyStatus.EXPIRED:
        return 'Expired'
      case Enums.CompanyStatus.REVOKED:
        return 'Revoked'
      default:
        return value
    }
  }
}
